export default "__VITE_PUBLIC_ASSET__7f2cab67__"